import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import type { RootState } from '@/app/store';
import { drawerName } from '@/constants/index';

export const useGetDrawerPath = () => {
  const { mapTypeFlg } = useSelector((state: RootState) => state.spot);
  const location = useLocation();
  const pathname = location.pathname;

  const matchedDrawerName: string = Object.values(drawerName).find((name) =>
    pathname.includes(name)
  );

  if (matchedDrawerName) {
    return `/${mapTypeFlg}/${matchedDrawerName}${location.search}`;
  }

  return undefined;
};
